import { render, staticRenderFns } from "./pdateCard.vue?vue&type=template&id=22d8ab9e&"
import script from "./pdateCard.vue?vue&type=script&lang=js&"
export * from "./pdateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports